import { QueryStringParameters } from './query-string-parameters';
/**
 * This class uses the QueryStringParameters class to generate the final API endpoint
 */
export class UrlBuilder {
  public url: string;
  public queryString: QueryStringParameters;
  constructor(
    private baseUrl: string,
    private action: string,
    queryString?: QueryStringParameters
  ) {
    const normalizedBaseUrl = baseUrl.replace(/\/+$/, '');
    const normalizedAction = action.replace(/^\/+/, '');
    this.url = `${normalizedBaseUrl}/${normalizedAction}`;
    this.queryString = queryString || new QueryStringParameters();
  }
  public toString(): string {
    const qs: string = this.queryString ? this.queryString.toString() : '';
    const formattedUrl = this.url.replace(/\/+$/, '');
    return qs ? `${formattedUrl}?${qs}` : formattedUrl;
  }
}
